import React from 'react';
import { Text, i18n, tokens, localizationMaps } from '@simplybenefits/sb-ui-library';
import { helpers } from '@simplybenefits/sb-utils';

// For fixing items that don't camel case well in the database.
const map = {
    'apneaMachine': 'Apnea Machine (CPAP)',
    'artificialEyeLimb': 'Artificial Eye/Limb',
    'artificialEyeLimbRepairReplacement': 'Artificial Eye/Limb Repair/Replacement',
    'glucoseMonitoringEquipmentSupplies': 'Glucose Monitoring Equipment and Supplies',
    'tensMachine': 'TENS Machine',
    'wheelchairManual': 'Wheelchair - Manual',
    'wheelchairElectric': 'Wheelchair - Electric',
    'orthopedicShoesMaximum': 'Orthopedic Shoes',
    'orthopedicShoesPairsPerYear': 'Orthopedic Shoes'
};

const styles = {
    row: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 5
    }
};

/**
 * 
 * @param {*} classes 
 * @param {*} item 
 * @param {*} coverage 
 * @returns 
 */
const _renderPercentItem = (item, coverage) => (
    <div key={item} style={styles.row}>
        <Text small customStyle={{ flex: 1 }}>
            { localizationMaps.fromEnglish("benefits", helpers.camelToNormalCase(item)) }
        </Text>
        <Text small>{ `${ coverage[item] }%` }</Text>
    </div>
);

/**
 * 
 * @param {*} classes 
 * @param {*} item 
 * @param {*} coverage 
 * @returns 
 */
const _renderDaysItem = (item, coverage) => (
    <div key={item} style={styles.row}>
        <Text small customStyle={{ flex: 1 }}>
            { localizationMaps.fromEnglish("benefits", helpers.camelToNormalCase(item)) }
        </Text>
        <Text small>{coverage[item]}</Text>
    </div>
);

/**
 * 
 * @param {*} classes 
 * @param {*} item 
 * @param {*} coverage 
 * @returns 
 */
const _renderItem = (item, coverage) => (
    <div key={item} style={styles.row}>
        <Text small customStyle={{ flex: 1 }}>
            { map[item] ? localizationMaps.fromEnglish("benefits", map[item]) : localizationMaps.fromEnglish("benefits", helpers.camelToNormalCase(item)) }
        </Text>
        <Text small>{ `$${ helpers.numberWithCommasDecimals(coverage[item]) }` }</Text>
    </div>
);

/**
 * 
 * @param {*} item 
 * @param {*} coverage 
 * @returns 
 */
const _renderUnitItem = (item, coverage) => (
    <div key={item} style={{ display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', marginTop: "5px" }}>
        <Text small customStyle={{ flex: 1 }}>
            { map[item] ? localizationMaps.fromEnglish("benefits", map[item]) : localizationMaps.fromEnglish("benefits", helpers.camelToNormalCase(item)) }
        </Text>
        <Text small>{ `${ coverage[item] } ${ coverage[item] === 1 ? i18n.t(tokens.labels.coverage.unit) : i18n.t(tokens.labels.coverage.units) }` }</Text>
    </div>
);

/**
 * 
 * @param {*} item 
 * @param {*} coverage 
 * @returns 
 */
const _renderPair = (item, coverage) => (
    <div key={item} style={{ display: 'flex', flex: 1, flexDirection: 'row', alignItems: 'center', marginTop: "5px" }}>
        <Text small customStyle={{ flex: 1 }}>
            { map[item] ? localizationMaps.fromEnglish("benefits", map[item]) : localizationMaps.fromEnglish("benefits", helpers.camelToNormalCase(item)) }
        </Text>
        <Text small>{ coverage[item] === 1 ? i18n.t(tokens.labels.coverage.pairLimit, { limit: coverage[item] }) : i18n.t(tokens.labels.coverage.pairsLimit, { limit: coverage[item] }) }</Text>
    </div>
);

/**
 *
 * @param {*} param0
 */
const CoverageBlockMedical = ({ coverage }) => Object.keys(coverage).map((item) => {
    if (
        (typeof coverage[item] === 'number' &&
        // Make sure there is a value associated with each row that isn't 0
        coverage[item] > 1 &&
        !item.includes('Ends') &&
        !item.includes('Deductible') &&
        !item.includes('deductible') &&
        !item.includes('Period') &&
        !item.includes('Age') &&
        !item.includes('Date') &&
        !item.includes('Week') &&
        !item.includes('Survivor') &&
        !item.includes('reimbursement') &&
        !item.includes('laserEye') &&
        !item.includes('genderAffirmation') &&
        !item.includes('orthopedicShoes')) || // Orthopedic shoes are set on toggle and checked below
        item === 'artificialEyeLimb' || // item is stored as 1 (unit), per lifetime
        (item === 'orthopedicShoesPairsPerYear' && coverage.orthopedicShoesMaximumType === 'pairs' && coverage.includeOrthopedicShoes) ||
        (item === 'orthopedicShoesMaximum' && coverage.orthopedicShoesMaximumType === 'dollar' && coverage.includeOrthopedicShoes)
    ) {
        if (item.includes("hospitalBenefits") ||
            item.includes("convalescentHospitalReimbursement") ||
            item.includes("diagnosticServicesReimbursement") ||
            item.includes("dentalAccidentReimbursement") ||
            item.includes("medicalReferralReimbursement") 
        ) {
            return _renderPercentItem(item, coverage);
        }

        if (item.includes("convalescentHospitalMaxDays")) {
            return _renderDaysItem(item, coverage);
        }

        if (item === "artificialEyeLimb") {
            return _renderUnitItem(item, coverage);
        }

        if (item === "orthopedicShoesPairsPerYear") {
            return _renderPair(item, coverage);
        }

        return _renderItem(item, coverage);
    }


    return true;
});


export default (CoverageBlockMedical);